module.exports = __webpack_public_path__ + "img/vpn-public-wifi-security.8b344bb1.png";